import { defineStore } from 'pinia'

interface Page {
  type: 'content' | 'category' | null
  pendingNavigation: boolean
  currentArticleId: number | null
  currentCategoryId: number | null
}

export const usePageStore = defineStore('page', {
  state: () => ({
    page: {
      type: null,
      pendingNavigation: false,
      currentArticleId: null,
      currentCategoryId: null,
    } as Page,
  }),
})
